<template>
    <div
        class="preview-card"
        :class="classObject"
    >
        <div class="preview-card__img" :style="`background-image: url(${image});`"></div>
        <div class="preview-card__preview">
            <z-caption class="white-text u-collapse--all" size="l" v-if="title">
                <span v-html="title"></span>
            </z-caption>
        </div>
        <div class="preview-card__detail">
            <slot name="detail" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'preview-card',
    props: {
        fullHeight: {
            type: Boolean,
            default: false
        },
        minHeight: {
            type: Boolean,
            default: true
        },
        image: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
        }
    },
    computed: {
        classObject () {
            return {
                'preview-card--min-height': this.minHeight,
                'preview-card--full-height': this.fullHeight
            }
        }
    }
}
</script>

<style lang="scss">
.preview-card {
    $parent: &;
    position: relative;
    overflow: hidden;

    &--min-height {
        min-height: 600px;
    }

    &--full-height {
        height: 100%;
    }

    &:before {
        content: '';
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: linear-gradient(180deg, rgba(0, 59, 113, 0.096) -4.58%, rgba(6, 35, 63, 0.8) 71.44%), linear-gradient(0deg, rgba(0, 59, 113, 0.4), rgba(0, 59, 113, 0.4));
        transition: opacity $transition;
        opacity: 0;
        pointer-events: none;
        z-index: 2;
    }

    &__img {
        background-size: cover;
        background-position: 50% 50%;
        background-repeat: no-repeat;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        transform-origin: bottom center;
        transition: transform $transition;
        z-index: 1;
    }

    &__preview {
        padding-left: $token-spacers-s;
        padding-right: $token-spacers-s;
        @include padding-level(top, 2XL);
        @include padding-level(bottom, 2XL);
        position: absolute;
        height: 100%;
        width: 100%;
        left: 0;
        top: 0;
        display: flex;
        align-items: flex-end;
        transition: opacity $transition;
        z-index: 3;
    }

    &__detail {
        opacity: 0;
        pointer-events: none;
        padding-left: $token-spacers-s;
        padding-right: $token-spacers-s;
        @include padding-level(top, M);
        @include padding-level(bottom, M);
        transition: opacity $transition;
        z-index: 3;
        position: relative;
        height: 100%;
    }

    &:hover {
        &:before {
            opacity: 0.7;
        }

        #{$parent}__preview {
            opacity: 0;
        }

        #{$parent}__detail {
            opacity: 1;
            pointer-events: auto;
        }

        #{$parent}__img {
            transform: scale(1.1);
        }
    }

}

</style>
